import React from "react";
import { useLocation } from "react-router-dom";
import StatusBar from "components/StatusBar";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import Button from "components/Button";
import ModalBillToRoom from "screens/ModalBillToRoom";
import ModalAddVoucher from "screens/ModalAddVoucher";
import { useMutation } from "@apollo/client";
import { REDEEM_VOUCHER } from "graphql/service";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import { InfoContainer, VoucherContainer } from "./styles";
import colors from "constants/colors";

const BookingInformation = ({ groupId,booking }) => {

  const location = useLocation();
  const bill = location.state?.bill;

  const [redeemVoucher, { loading: redeemVoucherLoading }] = useMutation(REDEEM_VOUCHER, {
  });

  const handleRedeemVoucher = () => {
    redeemVoucher({
      variables: {
        bookingId: booking.bookingId,
      }
    })
  };

  return (
    <Card
      additionalstyle={`
        :hover {
          outline: 1px solid ${colors.green};
        }
      `} 
    >
      <CardHeader>
        <div className="cardTitle">
          <div>
            <span>ROOM {booking.roomBookings[0]?.room?.roomNumber} </span>
            <span className="greyOut">
              {booking.roomBookings[0]?.room?.roomType?.name}
            </span>
          </div>
          <StatusBar status={booking.status} />
        </div>
      </CardHeader>
      <InfoContainer>
        <div className="name">
          <div className="label">NAME</div>
          <div className="value">{booking.guest?.name}</div>
        </div>
        <div className="email">
          <div className="label">EMAIL</div>
          <div className="value">{booking.guest?.email}</div>
        </div>
        <div className="phone">
          <div className="label">PHONE</div>
          <div className="value">{booking.guest?.phone}</div>
        </div>
        <div className="checkInDate">
          <div className="label">CHECK-IN</div>
          <div className="value">
            <span>{moment(booking.checkInDate).tz(TIME_ZONE).format("MM/DD/YYYY")}</span>
            <span>{moment(booking.checkInDate).tz(TIME_ZONE).format("hh:mm A")}</span>
          </div>
        </div>
        <div className="checkOutDate">
          <div className="label">CHECK-OUT</div>
          <div className="value">
            <span>{moment(booking.checkOutDate).tz(TIME_ZONE).format("MM/DD/YYYY")}</span>
            <span>{moment(booking.checkOutDate).tz(TIME_ZONE).format("hh:mm A")}</span>
          </div>
        </div>
      </InfoContainer>
      <Card
        additionalstyle={`
          border: 1px solid ${colors.darkGrey};
          margin-top: 16px;
        `}
      >
        <CardHeader>
          <div className="cardTitle">
            CAFE ACTIONS
          </div>
          <div className="buttonContainer">
            <ModalBillToRoom
              selectedBookingId={booking.bookingId}
              buttonStyle={`
                width: 104px;
              `}
            />
          </div>
        </CardHeader>
        <CardHeader>
          <div className="cardTitle">
            BREAKFAST VOUCHERS
          </div>
          <div className="buttonContainer">
            <Button
              mainPage
              success
              disabled={booking.voucher?.redeemed === booking.voucher?.amount}
              onClick={handleRedeemVoucher}
              data-loading={redeemVoucherLoading}
              additionalstyle={`
                width: 130px;
              `}
            >
              {redeemVoucherLoading ? null: 'Redeem Voucher'}
            </Button>
            <ModalAddVoucher
              selectedBookingId={booking.bookingId}
              voucherPrice={bill?.breakfastVoucherPrice}
              buttonStyle={`
                width: 106px;
                margin-left: 16px;
              `}
            />
          </div>
        </CardHeader>
        <VoucherContainer>
          <div className="total">
            <div className="label">TOTAL</div>
            <div className="value">{booking.voucher?.amount || 0}</div>
          </div>
          <div className="redeemed">
            <div className="label">REDEEMED</div>
            <div className="value">{booking.voucher?.redeemed || 0}</div>
          </div>
        </VoucherContainer> 
      </Card>
    </Card>
  );
};

export default BookingInformation;
